export default "__VITE_ASSET__Bxio16j$__"